import { Injectable } from '@angular/core';
import { APIService } from '../shared/service/api.service';

@Injectable({ providedIn: 'root' })
export class FormularioService {
  constructor(private api: APIService) { }
  postForm(form) {
    const formData = new FormData();
    for (const key in form) {
      if (key !== 'reCaptcha') {
        const value = form[key] ? form[key] : '';
        formData.append(`${key}`, value);
      }
    }

    return this.api.postConsultaPublica(form);
  }

  getFormFields() {
    return {
      localAlteracao: [
        'Apresentação do Catálogo (novo formato)',
        'Curso',
        'Eixo tecnológico'
      ],
      camposCurso: [
        {
          label: 'Código Cine',
          fields: {
            proposta: 'propostaCodCine',
            justificativa: 'justificativaCodCine',
          },
          checkbox: 'codCine',
        },
        {
          label: 'Perfil profissional de conclusão',
          fields: {
            proposta: 'propostaPerfilProfissional',
            justificativa: 'justificativaPerfilProfissional'
          },
          checkbox: 'perfProf',
        },
        {
          label: 'Carga horária mínima',
          fields: {
            proposta: 'propostaCargaHoraria',
            justificativa: 'justificativaCargaHoraria'
          },
          checkbox: 'cargaH',
        },
        {
          label: 'Pré-requisitos para ingresso',
          fields: {
            proposta: 'propostaPreRequisitoIngresso',
            justificativa: 'justificativaPreRequisitoIngresso',
          },
          checkbox: 'preRec',
        },
        {
          label: 'Itinerários formativos',
          fields: {
            proposta: 'propostaPossibilidadeProsseguimentoEstudo',
            justificativa: 'justificativaPossibilidadeProsseguimentoEstudo',
          },
          checkbox: 'itiF',
        },
        {
          label: 'Campo de atuação',
          fields: {
            proposta: 'propostaCampoAtuacao',
            justificativa: 'justificativaCampoAtuacao',
          },
          checkbox: 'campoAt',
        },
        {
          label: 'Ocupações CBO associadas',
          fields: {
            proposta: 'propostaOcupacoesCbo',
            justificativa: 'justificativaOcupacoesCbo',
          },
          checkbox: 'ocupCBO',
        },
        {
          label: 'Infraestrutura mínima',
          fields: {
            proposta: 'propostaInfraestruturaMinima',
            justificativa: 'justificativaInfraestruturaMinima',
          },
          checkbox: 'infMin',
        },
        {
          label: 'Outros',
          fields: {
            proposta: 'propostaOutros',
            justificativa: 'justificativaOutros',
          },
          checkbox: 'outros',
        },
      ],
      textoTermo: 'Autorizo o Ministério da Educação e a equipe responsável pela atualização dos Catálogos Nacionais de Cursos a entrarem em contato comigo pelo endereço de e-mail informado neste formulário para tirar dúvidas e complementar informações.'
    };
  }
}
